/**
 * Esqueleto do quadro de Oportunidades: cinco colunas com o cabeçalho e
 * dois ou três cartões cada, no mesmo lugar em que o quadro vai aparecer.
 * Só usa classes do `PipelineBoard.css` — a versão anterior apontava para
 * `.pipeline-container`/`.pipeline-header`, que não existiam em CSS nenhum.
 */
const ALTURAS = [[96, 69, 96], [96, 96], [118, 96, 69], [96], [96, 96, 96]];

const PipelineSkeleton = () => (
    <div className="pl-board" aria-busy="true" aria-label="Carregando oportunidades">
        {ALTURAS.map((cartoes, i) => (
            <div key={i} className="pl-col">
                <div className="pl-col-head">
                    <span className="pl-skel" style={{ width: 7, height: 7, borderRadius: '50%' }} />
                    <span className="pl-skel" style={{ width: 110, height: 12 }} />
                </div>
                <div className="pl-col-sum">
                    <span className="pl-skel" style={{ display: 'inline-block', width: 64, height: 10 }} />
                </div>
                <div className="pl-col-body">
                    {cartoes.map((h, j) => (
                        <div key={j} className="pl-skel" style={{ height: h, backgroundColor: 'var(--bg-secondary)' }} />
                    ))}
                </div>
            </div>
        ))}
        <div className="pl-col is-rail">
            <div className="pl-col-head" />
            <div className="pl-col-sum" />
            <div className="pl-rail-body" />
        </div>
    </div>
);

export default PipelineSkeleton;
